"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes")),
    _Uploader = require("../../Uploader");

require("../styles/_asset-description.scss");

function Description(a) {
  var b = a.title,
      c = a.subtitle;
  return _react["default"].createElement("div", {
    className: "upload-asset-description"
  }, _react["default"].createElement("p", null, b), c ? _react["default"].createElement("p", null, c) : null);
}

function FileDescription(a) {
  var b = a.asset,
      c = a.sourceLink;
  if (!b) return _react["default"].createElement(Description, {
    title: "Video Embed",
    subtitle: c
  });

  try {
    var d = JSON.parse(b.metaData),
        e = d.type,
        f = d.size;
    return _react["default"].createElement(Description, {
      title: b.title,
      subtitle: "".concat(e, " - ").concat((0, _getDisplayBytes["default"])(f))
    });
  } catch (a) {
    return _react["default"].createElement(Description, {
      title: b.title
    });
  }
}

var _default = (0, _Uploader.withAssetSelector)(FileDescription);

exports["default"] = _default;